// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"aacf0490","371":"7db7d90f","644":"9e2a8c8f","674":"f11d22e5","773":"18ddbcd7","937":"7f2355d4","977":"88e47272"}[chunkId] + ".chunk.css";
};